class Countdown {
    constructor() {

        const countdowns = document.querySelectorAll('.countdown-container');
        if (countdowns.length) {
            countdowns.forEach(countdown => {
                let timedata = countdown.getAttribute('data-time');
                let timetitle_nap = countdown.getAttribute('data-nap');
                let timetitle_ora = countdown.getAttribute('data-ora');
                let timetitle_perc = countdown.getAttribute('data-perc');
                let timetitle_masodperc = countdown.getAttribute('data-mp');

                if (!timetitle_nap) {
                    timetitle_nap = 'nap';
                }
                if (!timetitle_ora) {
                    timetitle_ora = 'óra';
                }
                if (!timetitle_perc) {
                    timetitle_perc = 'perc';
                }
                if (!timetitle_masodperc) {
                    timetitle_masodperc = 'mp';
                }

                const itemTemplateNap = `<span><span class="inum">%i</span><span class="ititle">%ttitle</span></span>`;
                const itemTemplateOra = `<span><span class="inum">%i</span><span class="ititle">%ttitle</span></span>`;
                const itemTemplatePerc = `<span><span class="inum">%i</span><span class="ititle">%ttitle</span></span>`;
                const itemTemplateMasodperc = `<span class="mp"><span class="inum">%i</span><span class="ititle">%ttitle</span></span>`;


                if (!timedata) {
                    return;
                }
                let endTime;
                if (/\d{4}-\d{2}-\d{2}/.test(timedata)) {
                    const date = timedata.split('-');
                    const ev = date[0];
                    const ho = +date[1] - 1;
                    const nap = +date[2] + 1;
                    endTime = new Date(ev, ho, nap);
                } else {
                    return;
                }

                const countDownDate = endTime.getTime();

                const times = this.calcTimes(countDownDate);
                let { days, hours, minutes, seconds } = times;

                let items = '';
                items += itemTemplateNap.replace('%i', days).replace('%ttitle', timetitle_nap);
                items += itemTemplateOra.replace('%i', hours).replace('%ttitle', timetitle_ora);
                items += itemTemplatePerc.replace('%i', minutes).replace('%ttitle', timetitle_perc);
                items += itemTemplateMasodperc.replace('%i', seconds).replace('%ttitle', timetitle_masodperc);
                countdown.innerHTML = items;

                const x = setInterval( () =>{
                    const res = this.updateItems(countDownDate, countdown);
                    if (res.distance < 0) {
                        clearInterval(x);
                    }
                }, 1000);
            });
        }
    }

    updateItems(countDownDate, countdown) {
        const times = this.calcTimes(countDownDate);

        let timeItems = countdown.querySelectorAll('.inum');
        if (timeItems.length) {
            timeItems.forEach((item, index) => {
                item.innerHTML = times[Object.keys(times)[index]];
            });
        }
        return times;
    }

    calcTimes(countDownDate)
    {
        const now = new Date().getTime();
        let distance = countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);

        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            distance: distance
        };
    }

}

export default Countdown;
